import { MarketType } from '@velocity-exchange/sdk';
import { ENUM_UTILS } from '@velocity-exchange/common';
import {
	MarketCategory,
	PERP_MARKET_CATEGORIES_CONFIG,
	SPOT_MARKET_CATEGORIES_CONFIG,
} from 'src/constants/markets';
import ScrollShadows from 'src/components/ScrollShadows';
import { useRef, memo, useMemo } from 'react';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import { usePrivyWalletContext } from 'src/providers/wallets/PrivyWalletProvider';

function MarketCategoryTabs({
	marketType,
	selectedCategory,
	setSelectedCategory,
}: {
	marketType: MarketType;
	selectedCategory: MarketCategory;
	setSelectedCategory: (category: MarketCategory) => void;
}) {
	const scrollableRef = useRef<HTMLDivElement>(null);
	const { isPrivyNativeAuth } = usePrivyWalletContext();

	const options = useMemo(() => {
		// Hide the spot category when Privy-native for now.
		if (isPrivyNativeAuth) {
			return PERP_MARKET_CATEGORIES_CONFIG.filter(
				(config) => config.value !== 'spot'
			);
		}

		return ENUM_UTILS.match(marketType, MarketType.PERP)
			? PERP_MARKET_CATEGORIES_CONFIG
			: SPOT_MARKET_CATEGORIES_CONFIG;
	}, [marketType, isPrivyNativeAuth]);

	if (options.length === 1) {
		return null;
	}

	return (
		<ScrollShadows
			scrollableRef={scrollableRef}
			gradientFromClassName="from-container-bg"
		>
			<div
				className="hidden-scroll flex max-w-full items-center gap-1 overflow-x-auto"
				ref={scrollableRef}
			>
				<Tabs
					size="sm"
					variant="secondary"
					options={options}
					activeTab={selectedCategory}
					onTabChange={setSelectedCategory}
				/>
			</div>
		</ScrollShadows>
	);
}

export default memo(MarketCategoryTabs);
